import rawDialCodes from "./phoneDialCodes.data.json";

export type PhoneDialCodeRaw = {
  code: string;
  country: string;
};

export type PhoneDialCodeOption = PhoneDialCodeRaw & {
  label: string;
  pickerValue: string;
};

export const DEFAULT_PHONE_DIAL_CODE = "+381";

function buildPhoneDialCodes(data: PhoneDialCodeRaw[]): PhoneDialCodeOption[] {
  const sorted = [...data].sort((a, b) => a.country.localeCompare(b.country, "en"));

  const serbiaIndex = sorted.findIndex(
    (item) => item.code === DEFAULT_PHONE_DIAL_CODE && item.country === "Serbia"
  );
  if (serbiaIndex > 0) {
    const [serbia] = sorted.splice(serbiaIndex, 1);
    sorted.unshift(serbia);
  }

  return sorted.map((item, index) => ({
    ...item,
    label: `${item.code} ${item.country}`,
    pickerValue: `${item.code}|${item.country}|${index}`,
  }));
}

export const PHONE_DIAL_CODES: PhoneDialCodeOption[] = buildPhoneDialCodes(rawDialCodes);

export function getDialCodePickerValue(dialCode: string): string | null {
  return PHONE_DIAL_CODES.find((item) => item.code === dialCode)?.pickerValue ?? null;
}

export function getDialCodeFromPickerValue(value: string | null | undefined): string {
  if (!value) return DEFAULT_PHONE_DIAL_CODE;

  const match = PHONE_DIAL_CODES.find((item) => item.pickerValue === value);
  if (match) return match.code;

  const [code] = String(value).split("|");
  return code || DEFAULT_PHONE_DIAL_CODE;
}
